import { createRoute } from "./createRoute.js";

/**
 * Paths where a version-mismatch reload is safe — the user is not mid-flow, so
 * a reload cannot lose unsaved work.
 *
 * Derived from the path builders rather than written out again, so a route that
 * moves takes its entry with it. The builders are the same ones the router and
 * every link use, which is what makes this list agree with the routes by
 * construction instead of by someone remembering.
 *
 * A path absent from here is never auto-reloaded, so omitting one is the safe
 * default — an assessment part-completed is worth more than a fresh bundle.
 */
export const RELOAD_SAFE_ROUTE_PATHS = [
  createRoute.home(),
  createRoute.signIn(),
  // A listing of young people holds nothing a reload could lose. The pages that
  // register or correct a record are deliberately absent: both hold a
  // half-typed form.
  createRoute.persons(),
  // An administrative listing holds little a reload could lose: the filter and
  // the page are re-derivable, no assessment is part-completed here, and the
  // dialog that adds an account or an organisation is a few fields to retype.
  createRoute.adminUsers(),
  createRoute.users(),
  createRoute.adminOrganisations(),
  createRoute.adminAuditTrail(),
  // Deliberately absent: the profile page and the account pages all hold a
  // half-typed name, and a reload underneath somebody correcting a name would
  // discard it.
] as const;
